import type { ThemeBackgroundColors, ThemeTextColor } from '@rover/kibble/styles';

import { KibbleFormFieldComponentCommonProps } from '../../types';
import { SharedTypographyProps } from '../sharedTypography';

export type SelectFieldVariant = {
  borderColor: string;
  textColor: ThemeTextColor;
  backgroundColor: ThemeBackgroundColors;
};

export type SelectFieldOptionConfig = {
  label: string;
  value: string;
};

export type SelectFieldCommonProps = KibbleFormFieldComponentCommonProps &
  SharedTypographyProps & {
    options: SelectFieldOptionConfig[];
    placeholder: string;
    onChange?: (selectedOption: SelectFieldOptionConfig['value']) => void;
    /** Controls the width of just the input part of the field */
    inputWidth?: string;

    /** only a single variant, so this type can be simple for now */
    variantOptions?: {
      /** A hardcoded width for the options dropdown */
      dropdownWidth?: string;
    };

    /** Only affects RxN; this adjusts for variable nav bar heights that are unfortunately defined in native code.
     * Please test on both iOS and Android and enter a separate height adjustment for each platform.
     * (This adjustment will usually be specific to the screen that the SelectField appears on.)
     */
    rxnNavBarHeightAdjust?: {
      ios?: number;
      android?: number;
    };
  };

export const getVariantStyles = (
  hasError: boolean,
  isSelected: boolean,
  isDisabled?: boolean
): SelectFieldVariant => {
  if (isDisabled) {
    return {
      borderColor: 'neutral.200',
      textColor: 'disabled',
      backgroundColor: 'interactive.disabled_base',
    };
  }

  return {
    borderColor: hasError ? 'border.error' : 'border.primary',
    textColor: isSelected ? 'primary' : 'tertiary',
    backgroundColor: 'primary',
  };
};
